module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_home2.2602b.png";